import { SOP } from '@radsource/ng-common-lib'
import { Injectable } from '@angular/core';
import { StudyInstance } from "./study-instance";
import { SeriesInstance } from "./series-instance";
import { PatientInstance } from "./patient-instance";
import { of } from 'rxjs'

@Injectable()
export class SOPInstance extends SOP {

  //PROPERTIES
  new_sop_instance_uid: string;
  thumbnail: any;
  thumbnail$: any;
  patient: PatientInstance;
  study: StudyInstance;
  series: SeriesInstance;

  pushProgress: any;
  pushProgress$: any;

  // ui variables
  loadingThumbnail: Boolean = false;

  //CONSTRUCTOR
  constructor();
  constructor(instance: any);
  constructor(instance?: any) {
    super(instance);
    this.new_sop_instance_uid = (instance && instance.new_sop_instance_uid) ? instance.new_sop_instance_uid : null;
    this.thumbnail = (instance && instance.thumbnail) ? instance.thumbnail : null;
    this.patient = (instance && instance.patient) ? new PatientInstance(instance.patient) : new PatientInstance();
    this.study = (instance && instance.study) ? new StudyInstance(instance.study) : new StudyInstance();
    this.series = (instance && instance.series) ? new SeriesInstance(instance.series) : new SeriesInstance();
  } //end constructor

  resetAllButThumbnail(): void {
    this.pushProgress = { state: 'QUEUED' };
    this.pushProgress$ = of(this.pushProgress);
  }

  update(inst: SOPInstance): void {
    this.record_id = inst.record_id;
    this.series_record_id = inst.series_record_id;
    this.instance_uid = inst.instance_uid;
    this.new_sop_instance_uid = inst.new_sop_instance_uid;
    this.instance_number = inst.instance_number;
    this.thumbnail = inst.thumbnail;
  }

} //end class